import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=f785b2a0&scoped=true&"
import script from "./counter.vue?vue&type=script&lang=js&"
export * from "./counter.vue?vue&type=script&lang=js&"
import style0 from "./counter.vue?vue&type=style&index=0&id=f785b2a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f785b2a0",
  null
  
)

export default component.exports